import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CreateSessionStepEnum } from '../../../shared/models/session-guide.model';

@Component({
  standalone: false,
  selector: 'app-create-session-step',
  templateUrl: './create-session-step.component.html',
  styleUrls: ['./create-session-step.component.scss'],
})
export class CreateSessionStepComponent {
  @Input() createSessionActiveStep: CreateSessionStepEnum;
  @Output() stepClick = new EventEmitter<CreateSessionStepEnum | null>();

  get isCreateSessionStepActive() {
    return this.createSessionActiveStep === CreateSessionStepEnum.CREATE_SESSION;
  }
  get isAddSuppliersStepActive() {
    return this.createSessionActiveStep === CreateSessionStepEnum.ADD_SUPPLIERS;
  }

  onContactClick(event: Event) {
    event.preventDefault();
    fcWidget.open();
  }

  onCreateSessionClick() {
    this.stepClick.emit(this.createSessionActiveStep === CreateSessionStepEnum.CREATE_SESSION ? null : CreateSessionStepEnum.CREATE_SESSION);
  }
  onAddSuppliersClick() {
    this.stepClick.emit(this.createSessionActiveStep === CreateSessionStepEnum.ADD_SUPPLIERS ? null : CreateSessionStepEnum.ADD_SUPPLIERS);
  }
}
